module.exports = __webpack_public_path__ + "img/140-Jet Black Stylo.jpg";